import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useQuery } from "convex/react";
import { api } from "../../../../../convex/_generated/api";
import { useAppAuth } from "@/contexts/AuthContext";
import { LoadingSpinner } from "../loading-spinner";

export function PlanLockoutGuard({ children }: { children: React.ReactNode }) {
  const { isOwner, isLoading: authLoading, isAuthenticated } = useAppAuth();
  const location = useLocation();

  // Get the current user to get their Convex orgId
  const currentUser = useQuery(api.users.getCurrentUser, isAuthenticated ? {} : "skip");
  
  // If no org (e.g. personal workspace or onboarding), bypass.
  const convexOrgId = currentUser?.orgId;
  const shouldFetchOrg = !!convexOrgId;
  const orgInfo = useQuery(api.organizations.getBasicInfo, shouldFetchOrg ? { id: convexOrgId } : "skip");

  if (authLoading || (isAuthenticated && currentUser === undefined)) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingSpinner className="h-8 w-8 text-brand-500" />
      </div>
    );
  }

  if (shouldFetchOrg) {
    if (orgInfo === undefined) {
      return (
        <div className="flex min-h-screen items-center justify-center">
          <LoadingSpinner className="h-8 w-8 text-brand-500" />
        </div>
      );
    }

    if (orgInfo !== null) {
      const planType = orgInfo.planType || "basic";
      const isIndividualPlan = ["basic", "starter", "professional"].includes(planType);

      // If it's an individual plan and the user is not the owner, lock them out.
      if (isIndividualPlan && !isOwner) {
        return <Navigate to="/locked-out" state={{ from: location }} replace />;
      }
    }
  }

  return <>{children}</>;
}
